// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  objectiveId: __t.u64().primaryKey().name("objective_id"),
  battleId: __t.u64().name("battle_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  radiusM: __t.f32().name("radius_m"),
  controller: __t.string(),
  claimant: __t.string(),
  state: __t.string(),
  progress: __t.f32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
